import { createContext, useState, useEffect, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import calcResolutionType from 'functions/calcResolutionType';
import RESOLUTION_TYPES from 'consts/resolutionTypes';

export const ResolutionTypeContext = createContext();

function isPhoneResolutionType(resolutionType) {
  return resolutionType === RESOLUTION_TYPES.PHONE || resolutionType === RESOLUTION_TYPES.TABLET;
}

export const ResolutionTypeContextProvider = () => WrappedComponent => {
  const ContextComponent = ({ ...props }) => {
    const [resolutionType, setResolutionType] = useState(calcResolutionType());

    const value = useMemo(
      () => ({
        resolutionType,
        isPhoneResolution: isPhoneResolutionType(resolutionType),
      }),
      [resolutionType],
    );

    useEffect(() => {
      const resizeHandler = () => {
        const newResolutionType = calcResolutionType();

        setResolutionType(newResolutionType);
      };

      window.addEventListener('resize', resizeHandler, { passive: false });

      return () => window.removeEventListener('resize', resizeHandler, { passive: false });
    }, []);

    return (
      <ResolutionTypeContext.Provider value={value}>
        <ThemeProvider theme={{ isMobile: value.isPhoneResolution }}>
          <WrappedComponent {...props} />
        </ThemeProvider>
      </ResolutionTypeContext.Provider>
    );
  };

  return ContextComponent;
};
